import axios from "axios";
import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiFinanceConfig() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
  const url = BASEURL + "financeConfig/";

  return {
    GetAll: () => authAxios.get(url + "Get"),
    Update: (id, record) =>
      authAxios.put(url + "Update/" + id, record),
  };
}

export default ApiFinanceConfig;
